export class TargetingRhpContextModel {
    key: number;
    takeOverKey: string;
    fullProfileKey: string;
}
